import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';
export const VisualRefreshChangeboarding = withAsync({
    loader: lazyForPaint(
        () => import(/* webpackChunkName: "visual-refresh-changeboarding" */ './visual-refresh-changeboarding')
    ),
    LoadingSkeleton: () => null,
});
